import { handleActions } from 'redux-actions'
import * as type from './type'
import { changeTableSettings, createInitialTableState } from '../../../form/state/table-state-helper'


export const initialState = {
    paymentList: [],
    payment: null,
    fetching: false,
    error: null,
    ...createInitialTableState({
        rowsPerPage: 10,
        sortColumnName: 'date',
        sortOrder: -1,
    }),
}


export default handleActions({
    [type.CHANGE_TABLE_SETTINGS]: changeTableSettings(),

    [type.FIND_UNASSIGNED_PAYMENT_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_UNASSIGNED_PAYMENT_LIST_SUCCESS]: (state, action) => {
        const { paymentList } = action.payload
        return {
            ...state,
            paymentList,
            fetching: false,
        }
    },
    [type.FIND_UNASSIGNED_PAYMENT_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.EDIT_UNASSIGNED_PAYMENT]: (state, action) => {
        const { payment } = action.payload
        return {
            ...state,
            payment,
        }
    },
    [type.CHANGE_CUSTOMER]: (state, action) => {
        const { customer } = action.payload
        return {
            ...state,
            payment: {
                ...state.payment,
                customer,
                customerId: customer.id,
                salesOrderId: null,
            },
        }
    },
    [type.CHANGE_SALES_ORDER]: (state, action) => {
        const { value } = action.payload
        return {
            ...state,
            payment: {
                ...state.payment,
                salesOrderId: value,
            },
        }
    },
    [type.ASSOCIATE_PAYMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.ASSOCIATE_PAYMENT_SUCCESS]: (state, action) => {
        const { paymentList } = action.payload
        return {
            ...state,
            paymentList,
            payment: null,
            fetching: false,
        }
    },
    [type.ASSOCIATE_PAYMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.DELETE_PAYMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.DELETE_PAYMENT_SUCCESS]: (state, action) => {
        const { paymentList } = action.payload
        return {
            ...state,
            paymentList,
            payment: null,
            fetching: false,
        }
    },
    [type.DELETE_PAYMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/payment/state/associate-payment/reducer.js